import { telLink } from "@/lib/business";

const Portrait = () => (
  <figure className="gr relative mx-auto w-[82%] max-w-[320px] sm:w-auto sm:max-w-none" data-testid="hero-portrait">
    <div className="absolute -top-3 -right-3 sm:-top-4 sm:-right-4 h-full w-full border-2 border-plate" aria-hidden="true" />
    <div className="relative overflow-hidden bg-stone aspect-[4/5] soft-photo">
      <img src="/owner.jpg" alt="Ihr Ansprechpartner bei PC Zulassungsdienst" className="h-full w-full object-cover object-[50%_30%]" />
    </div>
    <figcaption className="relative -mt-8 ml-4 sm:ml-6 inline-block bg-navy text-paper px-4 py-2.5 sm:px-5 sm:py-3 soft-card">
      <span className="lb block text-steel text-[10px] sm:text-xs">Ihr Ansprechpartner</span>
      <span className="dp text-xl sm:text-2xl">Persönlich. Schnell. Fair.</span>
    </figcaption>
  </figure>
);

export const Hero = () => (
  <section className="shade-paper text-ink pt-10 pb-14 sm:py-20 md:py-28 overflow-hidden" data-testid="hero-section">
    <div className="max-w-6xl mx-auto px-5 sm:px-6 grid md:grid-cols-[220px_1fr] gap-6 sm:gap-12">
      <aside className="lb text-inkmuted border-l-2 border-plate pl-3 sm:pl-4 h-fit text-[10px] sm:text-xs">
        <p>Kfz-Zulassungsdienst</p>
        <p className="mt-1 sm:mt-2">Berlin · An · Um · Ab</p>
      </aside>
      <div className="grid lg:grid-cols-[1fr_340px] gap-10 sm:gap-12 items-center min-w-0">
        <div className="min-w-0">
          <h1 className="dp pc-h1" data-testid="hero-headline">
            <span className="ln"><span>Kein Warten.</span></span>
            <span className="ln"><span className="text-plate">Zugelassen heute.</span></span>
          </h1>
          <p className="fu mt-4 sm:mt-6 max-w-md text-base sm:text-lg text-inkmuted" data-testid="hero-subline">
            Ich erledige Ihre Zulassung am selben Tag, zum fairen Festpreis.
          </p>
          <div className="fu fu2 mt-6 sm:mt-8 grid grid-cols-2 sm:flex sm:flex-wrap gap-3 sm:gap-4">
            <a href="#kontakt" className="group lb flex items-center justify-center text-center text-[11px] sm:text-xs bg-plate text-white px-3 sm:px-6 py-3.5 sm:py-4 transition-colors hover:bg-plate-hover" data-testid="hero-anfragen-btn">
              Zulassung anfragen{" "}
              <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
            </a>
            <a href={telLink} className="lb flex items-center justify-center text-center text-[11px] sm:text-xs border-2 border-ink px-3 sm:px-6 py-3 sm:py-4 transition-colors hover:bg-ink hover:text-paper" data-testid="hero-call-btn">
              Jetzt anrufen
            </a>
          </div>
        </div>
        <Portrait />
      </div>
    </div>
  </section>
);
